export default __webpack_public_path__ + "images/5bf71957f8bdc46f9c15a7bafdda96bb.svg";